(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/eid-sign/assets/javascripts/checker.js') >= 0) return;  svs.modules.push('/components/app/eid-sign/assets/javascripts/checker.js');
"use strict";


const checker = svs => {
  'use strict';

  const {
    MODE
  } = svs.app.eidSign.constants;

  class Checker {
    constructor(options) {
      const {
        ObservableModel
      } = svs.app.eidSign;
      const defaultProgressTextFreja = svs.core.detect.formfactor.mobile() ? 'Försöker starta Freja eID-appen' : 'Starta Freja eID-appen på din mobil eller surfplatta. Klicka på QR-ikonen och läs av QR-koden ovan med kameran.';
      const defaultProgressTextBankid = 'Försöker starta BankID-appen';
      const defaultProgressText = options.mode === MODE.BANKID ? defaultProgressTextBankid : defaultProgressTextFreja;
      this.model = new ObservableModel({
        error: false,
        progressStatus: 0,
        progressText: defaultProgressText,
        retry: 0
      });
      this.token = options.token;
      this.mode = options.mode || MODE.BANKID;
      this.logger = svs.core.log.getLogger("app:eid:".concat(this.mode, ":Checker"));
      this.isMobile = svs.core.detect.formfactor.mobile();
      this.stopPollingFlag = false;
      this.networkErrorRetries = 3;
      this.pollingTimeoutId = -1;

      this.frejaPollingCount = 0;
      this.frejaAuthRestarts = 0;
      this.frejaMaxPolling = svs.app.eidSign.freja.constants.MAXPOLLING_ATTEMPTS;
      this.frejaMaxRestarts = svs.app.eidSign.freja.constants.INITIAL_QRCODE_RETRIES; 

      this.errorHandler = xhr => {
        const {
          isProd
        } = svs.app.eidSign;
        const errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
        if (errorCode && errorCode === 666 && this.networkErrorRetries > 0) {
          this.networkErrorRetries = this.networkErrorRetries - 1;
          this.logger.info("Received network error when doing ".concat(this.mode, " signing, retrying. Retries left: ").concat(this.networkErrorRetries));
          this.pollingTimeoutId = setTimeout(this.checker, 1000);
        } else if (!this.isMobile && errorCode && (errorCode === svs.app.eidSign.bankid.constants.CUSTOMER_SCAN_TIMEOUT || !isProd && errorCode === svs.app.eidSign.bankid.constants.CUSTOMER_IDENTIFY_TIMEOUT) || errorCode === svs.app.eidSign.freja.constants.AUTHREF_NOT_FOUND_OR_EXPIRED) {
          this.logger.info("Received customer scan timeout when doing eidSign:".concat(this.mode, " signing, retrying eidSign:").concat(this.mode, "."));
          this.model.set({
            retry: this.model.get('retry') + 1
          });
        } else {
          this.model.set({
            error: xhr
          });
        }
      };

      this.successFn = resp => {
        let progressText = defaultProgressText;
        if (resp.postToken) {
          this.logger.debug("postToken: ".concat(resp.postToken));
          this.model.set('postToken', resp.postToken);
        } else if (resp.progressStatus || resp.status) {
          if (this.mode === MODE.BANKID) {
            this.logger.debug("progressStatus: ".concat(resp.progressStatus));
            switch (resp.progressStatus) {
              case 0:
              case 1:
              case 2:
                progressText = 'Försöker starta BankID-appen';
                break;
              case 3:
                progressText = 'Söker efter BankID, det kan ta en liten stund.';
                break;
              case 4:
              case 5:
              case 6:
                progressText = 'Skriv in din säkerhetskod i BankID-appen och välj Legitimera eller Skriv under.';
                break;
              default:
                this.logger.warn("Unhandled progress status: ".concat(resp.progressStatus));
            }
          } else if (this.mode === MODE.FREJA) {
            this.logger.debug("status: ".concat(resp.status));
            this.frejaPollingCount += 1; 
            switch (resp.status) {
              case 0:
              case 1:
                progressText = defaultProgressText;
                break;
              case 2:
                progressText = 'Godkänn i din Freja eID-app.';
                break;
              case 3:
                this.stopPolling(() => {
                  svs.ui.dialog.api.close(); 
                  this.frejaShowStatusMessage('Verifiering avbruten', 'Du har avbrutit verifieringen i Freja eID-appen.');
                }, false);
                break;
              case 4:
                this.stopPolling(() => {
                  svs.ui.dialog.api.close(); 
                  this.frejaShowStatusMessage('Verifiering avbruten', 'Verifieringen med Freja eID avbruten, var vänlig försök igen.');
                }, false);
                break;
              case 5:
                this.stopPolling(() => {
                  svs.ui.dialog.api.close(); 
                  this.frejaShowStatusMessage('Verifiering avbruten', 'Det tog för lång tid att godkänna din inloggning med Freja eID, var vänlig försök igen.');
                }, false);
                break;
              case 6:
                break;
              default:
                this.logger.warn("Unhandled progress status: ".concat(resp.status));
            }
          }
          this.model.set({
            progressStatus: resp.progressStatus || resp.status,
            progressText
          });
          if (!this.stopPollingFlag) {
            this.pollingTimeoutId = setTimeout(this.checker, 1000);
          }

          if (!this.isMobile && this.mode === MODE.BANKID && resp.progressStatus < 4) {
            this.qrCodeGenerate(resp.qrData); 
          }

          if (!this.isMobile && options.mode === MODE.FREJA && this.frejaPollingCount > this.frejaMaxPolling && this.frejaAuthRestarts <= this.frejaMaxRestarts) {
            this.frejaPollingCount = 0;
            this.frejaAuthRestarts += 1;
            if (this.frejaAuthRestarts === this.frejaMaxRestarts) {
              this.frejaAuthRestarts = 0;
            }

            this.stopPolling(() => {
              this.model.set({
                retry: this.model.get('retry') + 1
              });
            });
          }
        }
      };

      this.checker = () => {
        let path = '';
        let data = {};
        if (this.mode === MODE.BANKID) {
          path = '/player/1/authenticatesign/verify';
          data = {
            autoStartToken: this.token
          };
        } else if (this.mode === MODE.FREJA) {
          path = '/player/1/frejaeid/initauthsign/verify';
          data = {
            authRef: this.token
          };
        }
        svs.core.jupiter.call({
          path,
          method: 'POST',
          data,
          context: this
        }, this.successFn, this.errorHandler);
      };
      this.frejaCancelPoll = callback => {
        const options = {
          method: 'POST',
          path: '/player/1/frejaeid/cancelauth',
          context: this,
          data: {
            authRef: this.token
          }
        };
        svs.core.jupiter.call(options, function (response) {
          this.logger.info("Cancel poll: ".concat(response));
          callback === null || callback === void 0 || callback();
        }, function (xhr) {
          const errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
          this.logger.info(errorCode);
          callback === null || callback === void 0 || callback();
        });
      };
      this.frejaShowStatusMessage = (title, message) => {
        const dialog = new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.CONFIRM,
          icon: 'exclamation-sign',
          title,
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: message
          }],
          actions: [{
            title: 'Okej'
          }]
        });
        svs.ui.dialog.api.add(dialog);
        return false;
      };
    }

    qrCodeGenerate(qrCode) {
      if (qrCode && qrCode.length > 0) {
        const qrElement = document.querySelector('.qr-code');
        if (qrElement) {
          qrElement.innerHTML = '';
          $(qrElement).qrcode({
            size: 120,
            color: '#3a3',
            text: qrCode
          });
        }
      }
    }

    startPolling() {
      this.stopPollingFlag = false;
      this.networkErrorRetries = 3;
      this.frejaPollingCount = 0;
      this.checker();
    }

    stopPolling(callback) {
      let cancelAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.stopPollingFlag = true;
      if (this.pollingTimeoutId) {
        clearTimeout(this.pollingTimeoutId);
      }
      if (this.mode === MODE.FREJA && cancelAuth) {
        this.frejaCancelPoll(callback);
      } else {
        callback === null || callback === void 0 || callback();
      }
    }
  }
  svs.app.eidSign.Checker = Checker;
};
checker(svs);

 })(window);